"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _throbber = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/throbber"));

require("./LoadingThrobber.less");

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LoadingThrobber = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LoadingThrobber, _Component);

  var _super = _createSuper(LoadingThrobber);

  function LoadingThrobber(props) {
    (0, _classCallCheck2.default)(this, LoadingThrobber);
    return _super.call(this, props);
  }

  (0, _createClass2.default)(LoadingThrobber, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          size = _this$props.size,
          className = _this$props.className;
      var props = Object.assign({}, {
        'className': (0, _classnames.default)('primitive-loader', (_classNames = {}, (0, _defineProperty2.default)(_classNames, className, className), (0, _defineProperty2.default)(_classNames, size, size), _classNames))
      });
      return /*#__PURE__*/_react.default.createElement("div", props, /*#__PURE__*/_react.default.createElement("div", {
        className: "loading-wrapper text-center"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "loading-icon"
      }, /*#__PURE__*/_react.default.createElement(_throbber.default, {
        className: "spinner"
      }))));
    }
  }], [{
    key: "propTypes",
    value: function propTypes() {
      return {
        size: _propTypes.default.oneOf(['small', '']),
        className: _propTypes.default.string
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        size: '',
        className: ''
      };
    }
  }]);
  return LoadingThrobber;
}(_react.Component);

var _default = LoadingThrobber;
exports.default = _default;